export const DEFAULT_GL_THICKNESS_DECIMAL = '3.125'
export const DEFAULT_GL_THICKNESS_FRACTION = '3-1/8'

export const DEFAULT_EWP_THICKNESS_DECIMAL = '1.75'
export const DEFAULT_EWP_THICKNESS_FRACTION = '1-3/4'

const determineNewDimensionValue = (isGL: boolean, shouldUseDecimalValue: boolean) => {
    if (isGL) {
        return shouldUseDecimalValue ? DEFAULT_GL_THICKNESS_DECIMAL : DEFAULT_GL_THICKNESS_FRACTION
    }

    return shouldUseDecimalValue ? DEFAULT_EWP_THICKNESS_DECIMAL : DEFAULT_EWP_THICKNESS_FRACTION
}

const determineIfEWPDimensionShouldBeDecimal = (fieldDefaultValue: string) => {
    return fieldDefaultValue.includes('.')
}

export function defaultFormDataOnEWPChange(
    previousFormData: any,
    formData: any,
    fieldDefaultValue: string,
    ewpDimensionFieldName: string,
    ewpTypeFieldName: string,
    glValue: string,
    ewpSubFieldName?: string
) {
    const shouldUseDecimalValue = determineIfEWPDimensionShouldBeDecimal(fieldDefaultValue)

    const isPrevEWPValueGL = previousFormData[ewpTypeFieldName] === glValue
    const isCurEWPValueGL = formData[ewpTypeFieldName] === glValue

    if (isCurEWPValueGL !== isPrevEWPValueGL) {
        const newDimensionValue = determineNewDimensionValue(isCurEWPValueGL, shouldUseDecimalValue)

        if (!ewpSubFieldName) {
            formData[ewpDimensionFieldName] = newDimensionValue
        } else if (formData[ewpDimensionFieldName]) formData[ewpDimensionFieldName][ewpSubFieldName] = newDimensionValue
    }

    return formData
}
